import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserCheckFill = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.45823 3.45818C8.23182 2.6846 9.28103 2.25 10.375 2.25C11.4691 2.25 12.5183 2.6846 13.2919 3.45818C14.0654 4.23177 14.5 5.28098 14.5 6.375C14.5 7.46902 14.0654 8.51823 13.2919 9.29182C12.5183 10.0654 11.4691 10.5 10.375 10.5C9.28103 10.5 8.23182 10.0654 7.45823 9.29182C6.68464 8.51823 6.25004 7.46902 6.25004 6.375C6.25004 5.28098 6.68464 4.23177 7.45823 3.45818Z",
			fill: "currentcolor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.62026 12.5541C8.49263 12.1883 9.42911 12 10.375 12C12.2647 12 14.077 12.7507 15.4132 14.0869C16.7494 15.4231 17.5 17.2353 17.5 19.125V19.127L17.499 19.247C17.4968 19.3743 17.4622 19.4989 17.3986 19.6091C17.3349 19.7193 17.2442 19.8115 17.135 19.877C15.161 21.066 12.847 21.75 10.375 21.75C7.99278 21.7536 5.65484 21.106 3.61404 19.877C3.50508 19.8114 3.4146 19.7191 3.3511 19.6089C3.28759 19.4987 3.25317 19.3742 3.25104 19.247C3.23485 18.3012 3.40715 17.3616 3.75789 16.4831C4.10863 15.6046 4.6308 14.8047 5.29393 14.1302C5.95706 13.4556 6.74788 12.9198 7.62026 12.5541Z",
			fill: "currentcolor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4365 8.38478C22.6663 8.04013 22.5732 7.57448 22.2285 7.34471C21.8839 7.11495 21.4182 7.20808 21.1885 7.55272L18.3209 11.854L16.7178 10.2509C16.4249 9.95803 15.9501 9.95803 15.6572 10.2509C15.3643 10.5438 15.3643 11.0187 15.6572 11.3116L17.9072 13.5616C18.0661 13.7205 18.2878 13.7997 18.5114 13.7776C18.735 13.7555 18.9369 13.6342 19.0615 13.4473L22.4365 8.38478Z",
			fill: "currentcolor"
		})
	]
});
export default SvgUserCheckFill;
